// extracted by mini-css-extract-plugin
module.exports = {"reportContainer":"report_reportContainer__2aOn8","errorContainer":"report_errorContainer__1aPHE"};